import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("@/views/login/loginPage.vue"),
  },
  {
    path: "/",
    name: "home",
    meta: {
      title: "首页",
    },
    component: () => import("@/views/home/homePage.vue"),
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: "搜索",
    },
    component: () => import("@/views/home/search/searchPage.vue"),
  },
  {
    path: "/findTheLobby",
    name: "findTheLobby",
    meta: {
      title: "找大厅",
    },
    component: () => import("@/views/findTheLobby/theLobbyPage.vue"),
  },
  {
    path: "/possibleTasks",
    name: "possibleTasks",
    meta: {
      title: "找大厅详情",
    },
    component: () =>
      import("@/views/findTheLobby/possibleTasks/possibleTasksPage.vue"),
  },
  {
    path: "/pointDetails",
    name: "pointDetails",
    meta: {
      title: "服务点详情",
    },
    component: () =>
      import("@/views/findTheLobby/pointDetails/pointDetails.vue"),
  },

  {
    path: "/findServices",
    name: "findServices",
    meta: {
      title: "找服务",
    },
    component: () => import("@/views/findServices/servicesPage.vue"),
  },
  {
    path: "/servicesList",
    name: "servicesList",
    meta: {
      title: "找服务列表",
    },
    component: () =>
      import("@/views/findServices/servicesList/servicesList.vue"),
  },
  {
    path: "/serviceGuide",
    name: "serviceGuide",
    meta: {
      title: "服务指南",
    },
    component: () =>
      import("@/views/findServices/serviceGuide/serviceGuide.vue"),
  },
  {
    path: "/whatMaterials",
    name: "whatMaterials",
    meta: {
      title: "要什么材料",
    },
    component: () =>
      import("@/views/findServices/whatMaterials/whatMaterials.vue"),
  },
  {
    path: "/onlineProcessing",
    name: "onlineProcessing",
    meta: {
      title: "网上办",
    },
    component: () =>
      import("@/views/findServices/onlineProcessing/onlineProcessing.vue"),
  },
  {
    path: "/proposal",
    name: "proposal",
    meta: {
      title: "建议",
      requiresAuth: true
    },
    component: () => import("@/views/findServices/proposal/proposalPage.vue"),
  },
  {
    path: "/correction",
    name: "correction",
    meta: {
      title: "纠错",
      requiresAuth: true
    },
    component: () => import("@/views/findTheLobby/correction/correctionPage.vue"),
  },

  {
    path: "/my",
    name: "my",
    meta: {
      title: "我的",
    },
    component: () => import("@/views/my/myPage.vue"),
  },
  {
    path: "/mySetting",
    name: "mySetting",
    meta: {
      title: "我的设置",
      requiresAuth: true
    },
    component: () => import("@/views/my/mySetting/settingPage.vue"),
  },
  {
    path: "/myFeedback",
    name: "myFeedback",
    meta: {
      title: "我的反馈",
      requiresAuth: true
    },
    component: () => import("@/views/my/myFeedback/feedbackPage.vue"),
  },
  {
    path: "/myCollect",
    name: "myCollect",
    meta: {
      title: "我的收藏",
      requiresAuth: true
    },
    component: () => import("@/views/my/myCollect/collectPage.vue"),
  },
  {
    path: "/windowPhone",
    name: "windowPhone",
    meta: {
      title: "窗口电话",
    },
    component: () => import("@/views/home/windowPhone/phonePage.vue"),
  },
  {
    path: "/userService",
    name: "userService",
    meta: {
      title: "用户服务协议"
    },
    component: () => import("@/views/my/userService/userServicePage.vue"),
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    meta: {
      title: "隐私政策"
    },
    component: () => import("@/views/my/privacyPolicy/privacyPolicyPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
